import client from "./client";

const getWebhooks = () =>
  client.get("/subsidiary/dashboard/subsidiary/get-keys");

const getWebhooksUrl = () =>
  client.get("/subsidiary/static/account/default/webhook/view");

export default { getWebhooks, getWebhooksUrl };
